import { Columns } from "@fullscript/aviary-web";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { Button, EmptyState } from "@aviary";
import type { AviaryIllustration } from "@aviary/types";
import { l } from "@shared/locales/i18n";

import * as styles from "./CatalogEmptyState.styles";

interface Props {
  overrideHeader?: string;
  overrideMessage?: ReactNode;
  onClearAll?: () => void;
  action?: ReactNode;
  illustration?: AviaryIllustration;
  isSticky?: boolean;
}

const CatalogEmptyState = ({
  overrideHeader,
  overrideMessage,
  onClearAll,
  action,
  illustration = "lighthouse",
  isSticky,
}: Props) => {
  const { t } = useTranslation();

  const clearSearchButton = () => {
    if (action) return action;

    if (onClearAll) {
      return (
        <Button isColor="system" onClick={onClearAll}>
          {t(l.sharedCatalog.noResults.ClearSearch)}
        </Button>
      );
    }
  };

  const getHeader = () => {
    if (overrideHeader) {
      return overrideHeader;
    }

    return t(l.sharedCatalog.noResults.NoResultsFound);
  };

  const getMessage = () => {
    if (overrideMessage) {
      return overrideMessage;
    }

    return t(l.sharedCatalog.noResults.TryClearingSearch);
  };

  return (
    <Columns.Column columnWidth={12}>
      <EmptyState
        header={getHeader()}
        illustration={illustration}
        action={clearSearchButton()}
        css={[styles.container, isSticky && styles.sticky]}
      >
        {getMessage()}
      </EmptyState>
    </Columns.Column>
  );
};

export { CatalogEmptyState };
